import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import BoardIcon from '@atlaskit/icon/core/board';
import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
import { prioritizationProductDiscoveryProject } from '@atlassian/jira-project-template-select-v2/src/utils/templates/product-discovery/prioritization/index.tsx';
import { roadMapProductDiscoveryProject } from '@atlassian/jira-project-template-select-v2/src/utils/templates/product-discovery/product-roadmap/index.tsx';
import { productDiscovery } from '@atlassian/jira-project-template-select-v2/src/utils/templates/product-discovery/product-discovery/index.tsx';

import { expVal } from '@atlassian/jira-feature-experiments';
import LightBulb from '../../common/assets/light-bulb.svg';
import Compass from '../../common/assets/compass.svg';
import {
	deliveryIllustration,
	ideasIllustration,
	roadmapIllustration,
} from '../../common/ui/illustrations/index.tsx';
import type { TemplateKey } from '../types.tsx';
import messages from './messages.tsx';

export const templatesContentProject = {
	[prioritizationProductDiscoveryProject.key]: {
		logo: LightBulb,
		templateTitle: messages.projectTitlePrioritization,
		ariaLabel: messages.ariaLabel,
		projectNameDefault: messages.prioritizationProjectNameDefault,
		modalTitleDefault: messages.modalTitleDefault,
		projectDescription: messages.projectDescription,
		projectNameLabel: messages.projectNameLabel,
		projectNamePlaceholder: messages.projectNamePlaceholder,
		features: [
			{
				title: messages.ideas,
				icon: LightbulbIcon,
				description: messages.logIdeas,
				image: ideasIllustration,
			},
			{
				title: messages.roadmap,
				icon: BoardIcon,
				description: messages.shareRoadmaps,
				image: roadmapIllustration,
			},
			{
				title: messages.delivery,
				icon: CheckCircleIcon,
				description: messages.connectToJira,
				image: deliveryIllustration,
			},
		],
	},
	[roadMapProductDiscoveryProject.key]: {
		logo: Compass,
		templateTitle: messages.projectTitleProductRoadmap,
		ariaLabel: messages.ariaLabel,
		projectNameDefault: messages.roadmapProjectNameDefault,
		modalTitleDefault: messages.modalTitleDefault,
		projectDescription: messages.productRoadmapProjectDescription,
		projectNameLabel: messages.projectNameLabel,
		projectNamePlaceholder: messages.projectNamePlaceholder,
		features: [
			{
				title: messages.roadmap,
				icon: BoardIcon,
				description: messages.shareRoadmaps,
				image: roadmapIllustration,
			},
			{
				title: messages.ideas,
				icon: LightbulbIcon,
				description: messages.logIdeas,
				image: ideasIllustration,
			},
			{
				title: messages.delivery,
				icon: CheckCircleIcon,
				description: messages.connectToJira,
				image: deliveryIllustration,
			},
		],
	},
	[productDiscovery.key]: {
		logo: LightBulb,
		templateTitle: messages.projectTitleProductDiscovery,
		ariaLabel: messages.productDiscoveryAriaLabel,
		modalTitleDefault: messages.modalTitleDefault,
		projectDescription: messages.productDiscoveryProjectDescription,
		projectNameDefault: messages.productDiscoveryProjectNameDefault,
		projectNameLabel: messages.projectNameLabel,
		projectNamePlaceholder: messages.projectNamePlaceholder,
		features: [
			{
				title: messages.ideas,
				icon: LightbulbIcon,
				description: messages.logIdeas,
				image: ideasIllustration,
			},
			{
				title: messages.roadmap,
				icon: BoardIcon,
				description: messages.shareRoadmaps,
				image: roadmapIllustration,
			},
			{
				title: messages.delivery,
				icon: CheckCircleIcon,
				description: messages.connectToJira,
				image: deliveryIllustration,
			},
		],
	},
};

export const templatesContentSpace = {
	[prioritizationProductDiscoveryProject.key]: {
		logo: LightBulb,
		templateTitle: messages.projectTitlePrioritization,
		ariaLabel: messages.ariaLabel,
		projectNameDefault: messages.prioritizationProjectNameDefault,
		modalTitleDefault: messages.modalTitleDefaultGalaxia,
		projectDescription: messages.projectDescriptionGalaxia,
		projectNameLabel: messages.projectNameLabelGalaxia,
		projectNamePlaceholder: messages.projectNamePlaceholderGalaxia,
		features: [
			{
				title: messages.ideas,
				icon: LightbulbIcon,
				description: messages.logIdeas,
				image: ideasIllustration,
			},
			{
				title: messages.roadmap,
				icon: BoardIcon,
				description: messages.shareRoadmaps,
				image: roadmapIllustration,
			},
			{
				title: messages.delivery,
				icon: CheckCircleIcon,
				description: messages.connectToJira,
				image: deliveryIllustration,
			},
		],
	},
	[roadMapProductDiscoveryProject.key]: {
		logo: Compass,
		templateTitle: messages.projectTitleProductRoadmap,
		ariaLabel: messages.ariaLabel,
		projectNameDefault: messages.roadmapProjectNameDefault,
		modalTitleDefault: messages.modalTitleDefaultGalaxia,
		projectDescription: messages.onboardingTemplateProductRoadmapSpaceDescriptionGalaxia,
		projectNameLabel: messages.projectNameLabelGalaxia,
		projectNamePlaceholder: messages.projectNamePlaceholderGalaxia,
		features: [
			{
				title: messages.roadmap,
				icon: BoardIcon,
				description: messages.shareRoadmaps,
				image: roadmapIllustration,
			},
			{
				title: messages.ideas,
				icon: LightbulbIcon,
				description: messages.logIdeas,
				image: ideasIllustration,
			},
			{
				title: messages.delivery,
				icon: CheckCircleIcon,
				description: messages.connectToJira,
				image: deliveryIllustration,
			},
		],
	},
	[productDiscovery.key]: {
		logo: LightBulb,
		templateTitle: messages.projectTitleProductDiscovery,
		ariaLabel: messages.productDiscoveryAriaLabel,
		modalTitleDefault: messages.modalTitleDefaultGalaxia,
		projectDescription: messages.productDiscoveryProjectDescriptionGalaxia,
		projectNameDefault: messages.productDiscoveryProjectNameDefault,
		projectNameLabel: messages.projectNameLabelGalaxia,
		projectNamePlaceholder: messages.projectNamePlaceholderGalaxia,
		features: [
			{
				title: messages.ideas,
				icon: LightbulbIcon,
				description: messages.logIdeas,
				image: ideasIllustration,
			},
			{
				title: messages.roadmap,
				icon: BoardIcon,
				description: messages.shareRoadmaps,
				image: roadmapIllustration,
			},
			{
				title: messages.delivery,
				icon: CheckCircleIcon,
				description: messages.connectToJira,
				image: deliveryIllustration,
			},
		],
	},
};

export const getTemplateContentFromKey = (templateKey: TemplateKey) => {
	return expVal('project-terminology-refresh', 'isEnabled', false)
		? templatesContentSpace[templateKey]
		: templatesContentProject[templateKey];
};
